/**
 * Pages that never load analytics or session recording, whatever the visitor
 * chose in the cookie banner.
 *
 * - /embed: widgets on other sites. The embedding page owns its own consent.
 * - /email-preferences (29 Sep 2026): opened from an email with the reader's
 *   own token in the address (?t=). Google Analytics and Clarity record the
 *   page address, so a page whose address is a key to somebody's email
 *   switches must never be recorded. The page also takes the token out of the
 *   address bar as soon as it has read it.
 * - /tv (13 Oct 2026): the clubhouse TV display. Its address carries the
 *   display's key, and nobody is sitting at a wall screen to be measured.
 *
 * Pure, imported explicitly.
 */
export function analyticsFreeRoute(path) {
    if (typeof path !== 'string') return false;
    return path.startsWith('/embed') || isTvDisplay(path)
        || path === '/email-preferences' || path.startsWith('/email-preferences/');
}

const isTvDisplay = (path) => path === '/tv' || path.startsWith('/tv/');

/**
 * Pages that never show the cookie banner: there is nobody there to answer
 * it. Widgets sit inside another site's page, and a clubhouse TV is a wall
 * screen with no mouse, where the banner would cover the corner for good.
 * Both are analytics-free too, so there is nothing to ask about.
 */
export function cookieBannerFreeRoute(path) {
    if (typeof path !== 'string') return false;
    return path.startsWith('/embed') || isTvDisplay(path);
}

/**
 * The query without the email preferences token, for replacing the address
 * once the page holds the token in memory. Everything else (?type=) stays.
 */
export function queryWithoutToken(query) {
    const {t, ...rest} = query ?? {};
    return rest;
}
